import React from 'react'
import { View } from 'react-native'

import { ViewPropTypes } from 'deprecated-react-native-prop-types'
import PropTypes from 'prop-types'

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import { getThemeImages } from '../../Themes'

import styles from './StoreInfo.Styles'

const StoreInfo = ({ name, address, contactInfo, containerStyle, iconStyle, ...props }) => {
  const theme = useTheme()
  const images = getThemeImages(theme.name)

  return (
    <View style={[styles.storeContainerStyle(theme), containerStyle]}>
      <Icon name={images.store} size={25} style={[styles.storeIconStyle, iconStyle]} />

      <View style={styles.infoContainerStyle}>
        <VFText i18nKey={name} style={styles.storeNameTextStyle(theme)} />
        <VFText
          i18nKey={address?.name}
          style={styles.storeInfoTextStyle(theme)}
          numberOfLines={1}
        />
        {!!contactInfo?.email && <VFText
          i18nKey={contactInfo?.email}
          style={styles.storeInfoTextStyle(theme)}
          numberOfLines={1}
        />}
        {!!contactInfo?.phoneNumber && <VFText
          i18nKey={contactInfo?.phoneNumber}
          style={styles.storeInfoTextStyle(theme)}
          numberOfLines={1}
        />}
      </View>
    </View>
  )
}

StoreInfo.propTypes = {
  name: PropTypes.string.isRequired,
  address: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  contactInfo: PropTypes.shape({
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
  }).isRequired,
  containerStyle: ViewPropTypes.style,
  iconStyle: ViewPropTypes.style,
}

export default StoreInfo
